import HeartbeatLoader from 'components/Legacy/Icons/HeartbeatLoader'
import * as React from 'react'
import { px } from 'utils'

const Loader = () => <HeartbeatLoader className='loader' size={px('1rem')} />

export default Loader
